export const INCREMENT = 'counters/INCREMENT';
export const ADD = 'counters/ADD';
